<template>
  <div class="d-flex flex-column align-items-center">
    <h1 class="my-5 text-center">Смена пароля</h1>

    <input-form-custom
      class="password-input"
      name="old_password"
      v-model="oldPassword"
      label="Введите старый пароль"
      type="password"
    />
    <input-form-custom
      class="password-input"
      name="password"
      v-model="newPassword"
      label="Введите новый пароль"
      type="password"
    />
    <input-form-custom
      class="password-input"
      name="new_password_confirmation"
      v-model="newPasswordConfirmation"
      label="Введите новый пароль еще раз"
      :rule="{required: true, is: newPassword}"
      type="password"
    />

    <div v-if="error" class="alert alert-danger password-input">Неверный пароль</div>
    <div v-if="success" class="alert alert-success password-input">Пароль успешно изменен!</div>

    <btn-action class="btn btn-primary" @click="change">
      Сменить пароль
    </btn-action>
  </div>
</template>

<script>
  import BtnAction from '../../components/btn-action'
  import api from '@/api'

  export default {
    components: {BtnAction},
    data () {
      return {
        success: false,
        error: false,
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      }
    },
    methods: {
      change () {
        return this.$validator.validateAll().then(success => {
          if (success) {
            return api.post('refresh_password', {
              old: this.oldPassword,
              password: this.newPassword,
            }).then(() => {
              this.success = true
              this.error = false
            }).catch(() => {
              this.success = false
              this.error = true
            })
          }
        })
      },
    },
  }
</script>

<style lang="scss">
  .password-input {
    width: 40em !important;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/personal/refresh.vue